function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.147 12.7845L23.6897 13.5945L19.6782 17.5245L20.6233 23.0746L15.6668 20.456L10.7103 23.0746L11.6553 17.5245L7.64387 13.5945L13.1865 12.7845L15.6668 7.73163L18.147 12.7845ZM16.8112 5.7145L19.4151 11.024L25.2409 11.8782C26.2856 12.0306 26.7043 13.3258 25.9466 14.0677L21.7318 18.1982L22.7287 24.033C22.9081 25.0877 21.8036 25.8737 20.8785 25.3845L15.6668 22.6295L10.4551 25.3845C9.52998 25.8777 8.42543 25.0877 8.60487 24.033L9.60175 18.1982L5.38693 14.0677C4.6293 13.3258 5.04799 12.0306 6.09272 11.8782L11.9185 11.024L14.5224 5.7145C14.9929 4.75607 16.3447 4.7681 16.8112 5.7145Z",
  fill: "#D5D7DE"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.d276c1e9.svg";
export { ForwardRef as ReactComponent };